import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { LegislationCodeLevel } from '../level/LegislationCodeLevel';
import { Loader } from '../../../components/loader/Loader';
import { CodeInfos } from '../legislationCode.types';
import { LegislationArticlesContent } from './articles/LegislationArticlesContent';
import { Container } from '../../../../components/grid/Grid';
import styles from './legislation_code_content.module.scss';

type Props = {
  codeInfos: CodeInfos;
  date: string;
  isLoadingCode: boolean;
  isCode: boolean;
};

export const LegislationCodeContent: FC<Props> = ({
  codeInfos,
  date,
  isLoadingCode,
  isCode,
}) => {
  const { content, articles, textId, legId } = codeInfos;
  const source = isCode ? 'legislation-text' : 'legislation-section';

  if (isLoadingCode) {
    return <Loader />;
  }

  if (!content.length && !isLoadingCode) {
    return (
      <p className={styles.errorMsg}>
        <FormattedMessage id="code/LegislationCode.tsx/2" />
      </p>
    );
  }

  return (
    <Container className={styles.containerMargin}>
      {articles && !!articles.length && (
        <LegislationArticlesContent
          articles={articles}
          date={date}
          source={source}
        />
      )}
      {content.map((codeContent) =>
        codeContent?.legId || codeContent?.articles?.length ? (
          <LegislationCodeLevel
            key={codeContent.legId || codeInfos.legId}
            codeContent={codeContent}
            source={source}
            date={date}
            isCode={isCode}
            url={codeContent.url}
            textId={textId || legId}
          />
        ) : null,
      )}
    </Container>
  );
};
